import React, { ReactElement } from 'react';
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import classNames from 'classnames';

import styles from './YMap.module.scss';
import { IMapPosition } from "@common/redux/types/common";

interface IProps {
  mapPosition: IMapPosition,
  placeName: string,
  classes?: string
}

export const YMap = ({ mapPosition, placeName, classes }: IProps): ReactElement => {
  if (!mapPosition) {
    return (<></>);
  }
  const { coordinates } = mapPosition;

  return (
    <YMaps>
      <Map
        state={{
          center: coordinates,
          zoom: 15,
        }}
        options={{ suppressMapOpenBlock: true }}
        className={classNames([styles.map, classes && classes])}
      >
        <Placemark
          geometry={coordinates}
          properties={{
            hintContent: placeName || ''
          }}
          options={{
            iconLayout: 'default#image',
            iconImageSize: [38, 52],
            iconOffset: [-2, -13],
          }}
          modules={
            ['geoObject.addon.balloon', 'geoObject.addon.hint']
          }
        />
      </Map>
    </YMaps>
  );
};
